import { createFileRoute, redirect } from '@tanstack/react-router';
import { AuthGuard } from '@/components/auth/auth-guard';
import { AppLayout } from '@/components/layout';
import { useAuthStore } from '@/stores/auth';
import { useExtensionsStore } from '@/stores/extensions';
import { AiView } from '@/features/assistant/ai-view';

/**
 * The AI half of the product. Same workspace, driven by intent instead of by
 * navigation — no extra permission of its own, because everything it can reach
 * is already filtered by the capability registry on the server.
 */
export const Route = createFileRoute('/ai')({
  beforeLoad: () => {
    const gate = () => {
      if (!useAuthStore.getState().isAuthenticated) throw redirect({ to: '/login' });
    };
    if (useAuthStore.getState().isInitialized) {
      gate();
      return;
    }
    return useAuthStore.getState().initialize().then(gate);
  },
  component: AiRoute,
});

function AiRoute() {
  const isEnabled = useExtensionsStore((s) => s.isExtensionEnabled('ai-assistant'));

  return (
    <AuthGuard>
      <AppLayout>
        {isEnabled ? (
          <AiView />
        ) : (
          // Same shape as /boards and /time when their extension is off: a plain
          // sentence in the workspace chrome, not a redirect and not a crash.
          <div className="flex flex-col items-center justify-center py-32 text-center">
            <h2 className="text-lg font-semibold text-foreground mb-2">
              The AI Assistant is not enabled
            </h2>
            <p className="text-sm text-muted-foreground max-w-md">
              Enable the AI Assistant extension in Settings &rarr; Integrations to use the assistant.
            </p>
          </div>
        )}
      </AppLayout>
    </AuthGuard>
  );
}
